<template>
  <div>
    <!--<h3 v-show="searchTaxi">找尋中...</h3>-->
    <div class="row" v-if="checkCancelHailing">
      <div class="col-md-5 col-sm-5">
        <select
          id="heard"
          class="form-control"
          v-model="passengerMessage"
          required=""
          @change="optCancelNote(passengerMessage)"
        >
          <option :value="'抱歉! 乘客已取消本次派遣'">
            抱歉! 乘客已取消本次派遣
          </option>
          <option :value="'中心將取消本次派遣'">中心將取消本次派遣</option>
          <option :value="'辛苦了！未見乘客，請先離開，祝生意興隆'">
            辛苦了！未見乘客，請先離開，祝生意興隆
          </option>
          <option :value="'抱歉! 取消車趟，請車輛重新按排班'">
            抱歉! 取消車趟，請車輛重新按排班
          </option>
          <option :value="'抱歉! 乘客收線，中心取消本次派遣'">
            抱歉! 乘客收線，中心取消本次派遣
          </option>
        </select>
      </div>
      <div class="col-md-5 col-sm-5">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="備註"
          row="1"
          v-model="passengerCancelNote"
          maxlength="60"
        ></textarea>
      </div>
      <button
        class="btn-danger btn position"
        @click="afterCancelOrder"
        :class="{ disabled: isShowBtn }"
      >
        中心取消乘客叫車
      </button>
    </div>
    <!--v-show delete btn will display-->
    <!--v-show="isShowBeforeCancel"-->
    <!--v-show="orderIDArray.length"-->
    <button
      class="btn-danger btn position"
      v-else
      v-show="isShowBeforeCancel"
      :class="{ disabled: isShowBtn }"
      @click="beforeCancelOrder"
      style="float: right"
    >
      中心取消乘客叫車
    </button>
    <table class="table table-striped jambo_table bulk_action">
      <thead>
        <tr class="headings">
          <th class="column-title word_center">隊編/呼號</th>
          <th class="column-title word_center">司機電話</th>
          <th class="column-title word_center">司機備註</th>
          <th class="column-title word_center">預計時間(分)</th>
          <th class="column-title word_center">派遣方式</th>
          <th class="column-title word_center">狀況</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="pointer fontSize16 point text_hailing dropdown"
          v-for="(item, index) in hailingResultArray"
          :key="index"
        >
          <td class="word_center call-Number-click">
            {{ _callNumber(item.driverCallNumber, item.teamName) }}
          </td>
          <td class="word_center">{{ item.driverPhoneNumber }}</td>
          <th class="column-title word_center">{{ item.driverNote }}</th>
          <td class="word_center">
            {{ isShowEstimatedTime(item.estimatedTime) }}
          </td>
          <th class="column-title word_center">
            {{ item.shiftName || '空派' }}
          </th>
          <td
            class="word_center"
            :style="
              item.orderStatus === '無車輛可派' ? 'color:red' : 'color: black'
            "
          >
            {{ item.orderStatus }}
          </td>
        </tr>
      </tbody>
    </table>
    <button
      class="btn btn-default"
      default
      @click="recallHail"
      v-if="showHailingAgain"
    >
      再派一次
    </button>
    <div class="row" v-show="isShowNote">
      <div class="col-md-5 col-sm-5">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="備註"
          row="3"
          v-model="passengerNote"
          maxlength="60"
        ></textarea>
      </div>
      <!-- <button class="btn-success btn" @click="grabPhone">同來電</button> -->
      <button class="btn-primary btn" @click="sendNote">新增備註</button>
    </div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import Record_behavir from '../../assets/js/libs/FirebaseAPI/RecordBill'
var record = new Record_behavir()
export default {
  props: [
    'hailingResultArray',
    'showHailingAgain',
    'orderIDArray',
    'immediatelyNonTaxi',
    'initalHailingBillData',
    'immediatelyHailingCars',
    'passengerComment',
  ],
  name: 'hailingResult',
  data() {
    return {
      array: [],
      passengerMessage: '',
      passengerNote: '',
      orderId: '',
      cancelInfo: null,
      socket: null,
      messageResult: [],
      passengerCancelNote: '',
      isShowBtn: false,
    }
  },
  methods: {
    sendSns(item) {
      this.$emit('sendSns', item)
    },
    optCancelNote(val) {
      this.passengerCancelNote = val
    },
    _callNumber(driverCallNumber, teamName) {
      if (driverCallNumber === '') return ''
      const serviceTeamName = Cookies.get('GladTeamName')
      if (teamName === serviceTeamName) return driverCallNumber
      return `${teamName}- ${driverCallNumber}`
    },
    estimatedTime(value) {
      if (value.shiftProgram === 1) {
        return Math.ceil(value.estimatedTime)
      }
      return value.estimatedTime === 0 ? 1 : value.estimatedTime
    },
    deliverySocket(socket) {
      this.socket = socket
      this.socket.on('CancelOrder', async (data) => {
        if (data.success === true) {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '回傳取消'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = this.orderIDArray[0]
          recordInfo.note = JSON.stringify(data)
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          API.get(
            `pushMessage/?id=${this.orderIDArray[0]}&message=提醒:${this.orderIDArray[0]}單，乘客已取消`,
          )
            .then((res) => {
              this.isShowBtn = false
            })
            .catch((err) => {
              this.isShowBtn = false
            })
          alert('完成取消叫車')
          this.array.push({ result: '取消叫車' })
        }
        this.$emit('afterCancelRefresh')
      })
      this.socket.on('CancelMessage', async (data) => {
        if (data.success === true) {
          this.isShowBtn = false
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '中斷叫車'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = this.orderIDArray[0]
          recordInfo.note = JSON.stringify(data)
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          let result = {
            result: '中斷叫車',
            orderID: this.orderIDArray[0],
          }
          alert('取消成功')
          this.$emit('beforeCancel', result)
          return
        }
        if (data.success === false) {
          this.isShowBtn = false
          let result = {
            result: '取消失敗',
            orderID: this.orderIDArray[0],
          }
          this.$emit('beforeCancel', result)
        }
      })
    },
    sendNoteToManyDriver(val) {
      this.orderId = val
    },
    clearData() {
      this.passengerMessage = ''
      this.passengerNote = ''
      this.passengerCancelNote = ''
    },
    setContactPhoneInNote(phone) {
      if (phone) {
        this.passengerNote = '乘客電話:' + phone
      } else {
        this.passengerNote = '乘客電話:'
      }
    },
    sendNote() {
      if (this.orderIDArray.length === 0) {
        alert('沒有提取到派車單單號')
        return
      }
      const removeDuplicateId = [...new Set(this.orderIDArray)]
      // this.orderId = this.orderIDArray.join(",");
      this.orderId = removeDuplicateId.join(',')
      let payload = {
        passenger_note: this.passengerNote,
      }
      // console.log('=======>', this.orderIDArray)
      if (this.orderIDArray.length === 1) {
        this.sendSingleDriverForPassengerNote(this.orderId, payload)
        return
      }
      this.sendManyDriversForPassengerNote(this.orderId, payload)
      return
    },
    async beforeCancelOrder() {
      // this.$emit('stopCountTime')
      this.isShowBtn = true
      /* if (this.orderIDArray.length !== 1) {
        alert("提取派車單失敗" + `${this.orderIDArray.length}`);
        return;
      } */
      if (!this.orderIDArray.length) {
        alert('提取派車單失敗' + `${this.orderIDArray.length}`)
        return
      }
      this.$emit('cancelOrderFlag')
      // console.log("socket", this.socket);
      this.socket.emit('CancelMessage', {
        orderID: this.orderIDArray[0],
        passenMessage:
          26 + ',' + Cookies.get('GladName') + ',' + this.passengerCancelNote,
      })
      // 提醒司機端訂單取消
      // %0D%0A is the line break
      await API.get(
        `pushMessage/?id=${this.orderIDArray[0]}&message=乘客取消%0D%0A取消訂單編號：${this.orderIDArray[0]}%0D%0A訂單上車地點：${this.initalHailingBillData.onLocation}`,
      )
    },
    recallHail() {
      this.$emit('recall', this.nonTaxiCount)
      this.passengerNote = ''
    },
    afterCancelOrder() {
      // switch(this.passengerMessage){
      //     case 0:
      //         this.passengerMessage = '乘客已取消本次派遣乘客已取消本次派遣'
      //     break;
      //     case 1:
      //         this.passengerMessage = '中心將取消本次派遣'
      //     break;
      //     case 2:
      //         this.passengerMessage = '辛苦了！未見乘客，請先離開，祝生意興隆'
      //     break;
      //     case 3:
      //         this.passengerMessage = '抱歉! 取消車趟，請車輛重新按排班'
      //     break;
      //     case 3:
      //         this.passengerMessage = '抱歉! 乘客收線，中心取消本次派遣'
      //     break;
      // }
      this.isShowBtn = true
      this.socket.emit('CancelOrder', {
        success: true,
        passenMessage:
          26 + ',' + Cookies.get('GladName') + ',' + this.passengerCancelNote,
        passenStatus: 1,
        orderID: this.orderIDArray[0],
      })
    },
    controlShowBeforeBtn() {
      //   this.isShowBtn = true
    },
    sendSingleDriverForPassengerNote(id, payload) {
      API.put(`updatePassengerNote/?id=${id}`, payload)
        .then((data) => {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '更新乘客備註'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = id
          recordInfo.note = JSON.stringify(payload)
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          if (data.result[0].success) {
            API.get(`pushMessage/?id=${id}&message=提醒有新的乘客備註`)
              .then((res) => {
                if (res.result) {
                  alert('已傳送')
                  return
                }
                alert(
                  '備註更新完成，但未傳送給司機，如有需要再做一次備註更新。',
                )
              })
              .catch((err) => {
                console.log('intersectionInfo', err)
              })
            this.passengerNote = ''
            return
          }
          alert('資料更新失敗，導致無法傳送，請再試一次。')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    sendManyDriversForPassengerNote(id, payload) {
      // TODO:之後需要處理發送失敗的備註
      API.put(`updatePassengerNote/?id=${id}`, payload)
        .then((data) => {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '更新乘客備註'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = id
          recordInfo.note = JSON.stringify(payload)
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          let response = data.result
          let str = ''
          for (let i = 0; i < response.length; i++) {
            this.messageResult.push(response[i])
            str =
              str +
              `單號: ${response[i].orderID},${
                response[i].success ? '成功' : '失敗'
              };`
          }
          API.get(`pushMessage/?id=${this.orderId}&message=提醒有新的乘客備註`)
            .then((res) => {
              // console.log("pushmessage", res);
              if (res.result) {
                alert('傳送完成' + str)
              }
            })
            .catch((err) => {
              console.log('intersectionInfo', err)
            })
          this.passengerNote = ''
          return
        })
        .catch((err) => {
          console.log(err)
          return err
        })
    },
  },
  mounted() {
    this.$bus.$on('closeModal', (status) => (this.isShowBtn = status))
  },
  computed: {
    checkHailing: function () {
      if (this.hailingResultArray[0] === undefined) {
        this.beforeCancel = false
        // this.isAddnote = false
        return true
      }
      if (this.hailingResultArray[0].result === '無車輛可派。') {
        this.beforeCancel = false
        // this.isAddnote = false
        return true
      } else {
        this.beforeCancel = false
        return false
      }
    },
    nonTaxiCount() {
      // 計算多輛車下，沒有叫到幾台
      // 將結果陣列放進此方法，能夠計算目前還有哪幾輛沒叫到
      var count = 0
      try {
        for (let i = 0; i < this.hailingResultArray.length; i++) {
          if (this.hailingResultArray[i].result !== '無車輛可派。') {
            count += 1
          }
        }
        if (this.hailingResultArray.length - count === 0) {
          console.log('=========>', 1)
          return 1
        } else {
          console.log('=========>', this.hailingResultArray.length - count)
          return this.hailingResultArray.length - count
        }
      } catch (err) {
        console.log(err)
        return 1
      }
    },
    checkCancelHailing() {
      if (this.immediatelyHailingCars) {
        return false
      }
      if (
        this.hailingResultArray.length === 1 &&
        this.hailingResultArray[0].result !== '無車輛可派。'
      ) {
        // console.log("hailingResultArray ", this.hailingResultArray);
        return (
          this.hailingResultArray.length === 1 &&
          this.hailingResultArray[0].callNumber !== null
        )
      } else {
        return false
      }
    },
    isShowBeforeCancel: function () {
      if (this.immediatelyHailingCars) return false
      if (this.immediatelyNonTaxi) return false
      return this.orderIDArray.length > 0
    },
    isShowNote() {
      if (this.immediatelyNonTaxi) return false
      return this.orderIDArray.length > 0
    },
    isShowEstimatedTime() {
      return (time) => {
        // 如果是後派單就不要顯示時間
        if (this.passengerComment && this.passengerComment.includes('後派單')) {
          return '---'
        }
        return time
      }
    },
  },
}
</script>
<style scoped>
.call-Number-click {
  color: #3385ff;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/hailing/PhoneHailResultList.vue